import { useQuery } from "@tanstack/react-query";

import request from "app/api/request";
import { GenericPaginatedResponse } from "app/api/types";
import { AUTH_URL } from "app/constants/variables";
import parseError from "app/lib/parseError";
import { ExploreAnnouncement } from "app/models/banner";
import { AxiosError } from "axios";

const defaultOptions = {
  baseURL: AUTH_URL,
};

export default function useGetBanners() {
  const { data, error, refetch, isFetching, isLoading } = useQuery(
    ["banners"],
    () => {
      return request.get<GenericPaginatedResponse<ExploreAnnouncement>>(
        "/notification",
        defaultOptions
      );
    },
    {
      retry: false,
    }
  );

  return {
    banners: data?.data.data,
    error: error ? (parseError(error as AxiosError<{}>) as string) : undefined,
    getBanners: refetch,
    isFetching,
    isLoading,
  };
}
